"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogContentText.default;
  }
});

var _DialogContentText = _interopRequireDefault(require("./DialogContentText"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/DialogContentText/index.js
 ** module id = 664
 ** module chunks = 0
 **/